import Taxon from 'umg-ember-backend/components/record-explorer/for/taxon';

<template><Taxon @records={{@model}} @recordType='taxon' /></template>
